/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: Markdown rendering requires HTML */
import { marked } from 'marked';
import { useMemo } from 'react';
import { customMarkdownRenderer, walkTokens } from '@/lib/markdown/custom-renderer';
import { cn } from '@/lib/utils';
interface SimpleMarkdownProps {
  children: string;
  className?: string;
}
marked.setOptions({
  gfm: true,
  breaks: false
});
export const simpleMarkdownClassName = 'prose prose-cadence max-w-none [&_a]:transition-colors [&_a]:hover:text-brand-primary-hover';
export function SimpleMarkdown({
  children,
  className
}: SimpleMarkdownProps) {
  const html = useMemo(() => marked(children, {
    renderer: customMarkdownRenderer,
    walkTokens
  }) as string, [children]);
  const content = useMemo(() => ({
    __html: html
  }), [html]);
  return <div className={cn(simpleMarkdownClassName, className)} dangerouslySetInnerHTML={content} data-sentry-component="SimpleMarkdown" data-sentry-source-file="SimpleMarkdown.tsx" />;
}